export function resolveStoreCategory(storeOrCategory: any) {
  if (typeof storeOrCategory === "string") {
    return String(storeOrCategory || "GENERAL").toUpperCase()
  }

  return String(storeOrCategory?.category || storeOrCategory?.type || "GENERAL").toUpperCase()
}

export function isCarStore(storeOrCategory: any) {
  return resolveStoreCategory(storeOrCategory) === "CAR_BOUTIQUE"
}

export function isPropertyStore(storeOrCategory: any) {
  return resolveStoreCategory(storeOrCategory) === "REAL_ESTATE"
}

export function isMediaCatalogStore(storeOrCategory: any) {
  return isCarStore(storeOrCategory) || isPropertyStore(storeOrCategory)
}

export function getStoreProductRules(storeOrCategory: any) {
  const carStore = isCarStore(storeOrCategory)
  const propertyStore = isPropertyStore(storeOrCategory)
  const serviceStore = resolveStoreCategory(storeOrCategory) === "SERVICE_BUSINESS"
  const fashionStore = resolveStoreCategory(storeOrCategory) === "FASHION"

  return {
    isCarStore: carStore,
    isPropertyStore: propertyStore,
    isServiceStore: serviceStore,
    isMediaCatalogStore: carStore || propertyStore,
    itemLabel: carStore
      ? "véhicule"
      : propertyStore
        ? "bien"
        : serviceStore
          ? "service"
          : fashionStore
            ? "article de mode"
            : "produit",
    imageLabel: carStore
      ? "vehicule"
      : propertyStore
        ? "bien"
        : serviceStore
          ? "service"
          : fashionStore
            ? "article"
            : "produit",
    // Fashion items need fewer images than a car listing (4), but a single
    // lookbook shot is enough for a t-shirt or a pair of shoes.
    minimumImages: carStore ? 4 : propertyStore ? 3 : fashionStore ? 1 : 0,
  }
}

export function isCatalogStore(storeOrCategory: any) {
  const category = resolveStoreCategory(storeOrCategory)
  return (
    category === "GENERAL" ||
    category === "GYM" ||
    category === "CAR_BOUTIQUE" ||
    category === "REAL_ESTATE" ||
    category === "SERVICE_BUSINESS" ||
    category === "FASHION"
  )
}
